<dx-lookup [(value)]="value"
    [items]="proficiencyLevels"
    [disabled]="disabled"
    valueExpr="id"
    displayExpr="name"
    fullScreen="true"
    [placeholder]="'TXT_PLACEHOLDER_SELECT_PROFICIENCY_LEVEL' | translate">
</dx-lookup>